export const mainAccount = (state) => state.mainAccount;

export const accounts = (state) => state.accounts;
